import { COLORS, FONTS } from '@app/src/ui';
import styled from 'styled-components';

const ROOT = 'MyAccount/listAvailable/ActionsForAll';

export const Wrapper = styled.div`
  background: #f2f2f2;
  display: flex;
  height: 50px;
  align-items: center;
  width: 100%;
  padding: 0 15px;
  margin: 8px -15px -8px;
  flex: 1 1 100%;
  
  @media (min-width: 830px) {
    padding: 0 21px;
    max-width: 470px;
    flex: 1 1 470px;
    margin: 0 0 0 auto;
  }
`;

Wrapper.displayName = `${ROOT}/Wrapper`;

const Button = `
  font-family: ${FONTS.ROBOTO};
  font-size: 17px;
  cursor: pointer;
  border: 0;
  display: flex;
  align-items: center;
  & > svg {
    margin-right: 12px;
  }
`;

export const ButtonCancel = styled.button`
  ${Button}
  color: ${COLORS.BLACK_BOLD};
  font-size: 15px;
`;

ButtonCancel.displayName = `${ROOT}/ButtonCancel`;

export const ButtonClear = styled.button`
  ${Button}
  color: ${COLORS.RED_HIGHLIGHT};
  margin-left: auto;
`;

ButtonClear.displayName = `${ButtonClear}/Wrapper`;
